import * as actionTypes from "../actionTypes";
import {apiClient} from "../../../config/apiClient";
import * as ImmersionGQL from "../../../gql";

export const setLoading = (loading: boolean) => ({
  type: actionTypes.SET_MANAGER_LOADING,
  payload: loading
});

const setCodeLoading = (loading: boolean) => ({
  type: actionTypes.SET_CODE_LOADING,
  payload: loading
});

export const setFilter = (filter: boolean) => ({
  type: actionTypes.SET_FILTER,
  payload: filter
});

const getParticipantsCodeSuccess = (data: any) => ({
  type: actionTypes.GET_PARTICIPANTS_CODE_SUCCESS,
  payload: data
});

const getGraphDataSuccess = (activeParticipant: string, immersion: any, safety: any) => ({
  type: actionTypes.GET_GRAPH_DATA_SUCCESS,
  payload: {
    activeParticipant,
    immersion,
    safety
  }
});

const getStimulusInfoSuccess = (stimulus: any) => ({
  type: actionTypes.GET_STIMULUS_INFO_SUCCESS,
  payload: stimulus
});

export const removeParticipantGraphData = (participant: string) => ({
  type: actionTypes.REMOVE_PARTICIPANT_GRAPH_DATA,
  payload: participant
});

export const changeGraphType = (type: number) => ({
  type: actionTypes.CHANGE_GRAPH_TYPE,
  payload: type
});

export const setStart = (start: boolean) => ({
  type: actionTypes.SET_START,
  payload: start
});

const getGraphDataStartBtnSuccess = (activeParticipant: string, data: any) => ({
  type: actionTypes.GET_GRAPH_DATA_START_BTN_SUCCESS,
  payload: {
    activeParticipant,
    data
  }
});

export const updateTime = (time: string) => ({
  type: actionTypes.UPDATE_TIME,
  payload: time
});

export const updateRequestInterval = (interval: any) => ({
  type: actionTypes.UPDATE_REQUEST_INTERVAL,
  payload: interval
});

export const updateTimeInterval = (interval: any) => ({
  type: actionTypes.UPDATE_TIME_INTERVAL,
  payload: interval
});

export const startEpoch = () => ({
  type: actionTypes.START_EPOCH,
  payload: null
});


export const initLiveAnalysisData = () => ({
  type: actionTypes.INIT_LIVE_ANALYSIS_DATA,
  payload: {}
});

export const getSessionParticipantsSuccess = (items: any) => ({
  type: actionTypes.GET_SESSION_PARTICIPANT,
  payload: items,
});

export const updateStartPosition = (start: boolean) => ({
  type: actionTypes.UPDATE_START_POSITION,
  payload: start
});

export const updateImmersionData = (data: any) => ({
  type: actionTypes.UPDATE_IMMERSION_DATA,
  payload: data
});

export const updateSafetyData = (data: any) => ({
  type: actionTypes.UPDATE_SAFETY_DATA,
  payload: data
})

export const updateMarkerTime = (value: number, id: string, param: string) => ({
  type: actionTypes.UPDATE_MARKER_TIME,
  payload: {
    value,
    id,
    param
  }
})

export const removeMarkerData = (id: string) => ({
  type: actionTypes.REMOVE_MARKER_DATA,
  payload: id
})


export const updateSpecialProject = (projectId: number) => ({
  type: actionTypes.UPDATE_SPECIAL_PROJECT,
  payload: projectId
});

export const tagApplied = (tagApplied: boolean) => ({
  type: actionTypes.TAG_APPLIED,
  payload: tagApplied
});

const updateImmersionIndex = (data: any) => ({
  type: actionTypes.UPDATE_IMMERSION_INDEX,
  payload: data
});

const getOverviewData = (data: any) => ({
  type: actionTypes.SESSION_OVERVIEW,
  payload: data
});

const updateSafetyIndex = (data: any) => ({
  type: actionTypes.UPDATE_SAFETY_INDEX,
  payload: data
});

export const getImmersionCall = (request: any, type: string) => {
  return async (dispatch: any) => {
    try {
      const res = await apiClient(true)
        .post(`/aggregate/v2/${type}/index/immersion/97/a94nea8`, { ...request });
      if (res.data) {
        dispatch(updateImmersionData(res.data))
      } else {
        dispatch(updateImmersionData(null));
      }
    } catch (error) {

    }
  }
}

export const getSafetyCall = (request: any, type: string) => {
  return async (dispatch: any) => {
    try {
      const res = await apiClient(true)
        .post(`/aggregate/v2/${type}/index/safety/201/abcdefgh`, { ...request });
      if (res.data) {
        dispatch(updateSafetyData(res.data));
      } else {
        dispatch(updateSafetyData(null));
      }
    } catch (error) {

    }
  }
}

export const removeParticipants = async (participants: string[], session_code: string, client: any) => {
  const req = {
    participants,
    session_code
  }
  const variables = { ...req };
  const res = await client.mutate({
    mutation: ImmersionGQL.mutationRemoveParticipants,
    fetchPolicy: "no-cache",
    variables
  });
  return res;
}

export const addNewParticipants = (client: any, session_id: number, participants: any, hubs: any[], cb?: any) => {
  return (dispatch: any) => {
    const req = {
      session_id,
      participants,
      hubs
    };
    const variables = {...req};
    dispatch(setLoading(true));
    client.mutate({
      mutation: ImmersionGQL.mutationAddParticipants,
      fetchPolicy: "no-cache",
      variables
    }).then((res: any) => {
      if (res.data.addParticipants) {
        cb(res.data.addParticipants);
      }
      dispatch(setLoading(false));
    }).catch(() => {
      cb(null);
      dispatch(setLoading(false));
    })
  }
};

export const addNewParticipantTag = async (department_id: string,name: string, user_id: number, client: any) => {
  const req = {
    systemTag: false,
    tagType: 1, //for participants
    tagName: name,
    department_id: department_id,
    creatorUserId: user_id
  }
  const variables = { ...req };
  const res = await client.mutate({
    mutation: ImmersionGQL.mutationAddTag,
    fetchPolicy: "no-cache",
    variables
  });
  return res;
}

export const updateParticipantTag = async (client: any, request: any) => {
  const res = await client.mutate({
    mutation: ImmersionGQL.mutationUpdateTag,
    fetchPolicy: "no-cache",
    variables: {
      systemTag: false,
      tagType: 1, //for participants
      tagName: request.tagName,
      creatorUserId: request.user_id,
      tagDescription: request.tagDescription ? request.tagDescription : "",
      tagId: request.tagId,
      department_id: request.department_id,
    }
  });
  return res;
}

export const deleteParticipantTag = async (client: any, tagId: number, user_id: any) => {
  const res = await client.mutate({
    mutation: ImmersionGQL.mutationDeleteTag,
    fetchPolicy: "no-cache",
    variables: {
      tagId: tagId,
      user_id: user_id,
    }
  });
  return res;
}

export const getAllTagsByTypes = async (client: any, reqData: any) => {
  const req = {
    type: reqData.type,
    department_id: reqData.department_id,
  };
  const variables = { ...req };
  return await client.query({
    query: ImmersionGQL.queryViewTagsByTypes,
    fetchPolicy: "no-cache",
    variables
  });
};

export const updateParticipantsTags = async (client: any, req: any) => {
  const variables = { ...req };
  return await client.mutate({
    mutation: ImmersionGQL.mutationUpdateTags,
    fetchPolicy: "no-cache",
    variables
  });
};

export const removeParticipantsTags = async (client: any, req: any) => {
  const variables = { ...req };
  return await client.mutate({
    mutation: ImmersionGQL.mutationRemoveTags,
    fetchPolicy: "no-cache",
    variables
  });
}

export const getSessionIdByCode = (client: any, session_code: string, callback: any) => {
  return () => {
    client.query({
      query: ImmersionGQL.queryGetSessionParticipants,
      fetchPolicy: "no-cache",
      variables: {session_code: session_code}
    }).then((res: any) => {
      if (res.data.getSessionParticipants) {
        callback(res.data.getSessionParticipants);
      }
    }).catch(() => callback(null))
  }
};

export const getSessionParticipants = (client: any, req: any, cb?: any) => {
  return (dispatch: any) => {
    client.query({
      query: ImmersionGQL.queryGetSessionParticipants,
      fetchPolicy: "no-cache",
      variables: { session_code: req.session_code }
    })
      .then((response: any) => {
        if (response.data.getSessionParticipants) {
          const responsedata = response.data.getSessionParticipants;
          if(responsedata && responsedata.session && responsedata.session.session_id){
              localStorage.setItem("session_id", responsedata.session.session_id)
          }
          if(req.isloading){
            responsedata.isloading = true;
          }
          dispatch(getSessionParticipantsSuccess(responsedata));
          cb && cb(response.data.getSessionParticipants);
        }
      })
      .catch((e: any) => {
        let result = null;
        if (e.message && e.message === 'Error: INSUFFICIENT_PERMISSIONS') {
          result = "INSUFFICIENT_PERMISSIONS"
        }
        cb && cb(result);
      });
  };
};

export const getAsyncGraphData = async (request: any, type: string) => {
  return async (dispatch: any) => {
    dispatch(setLoading(true));
    const activeParticipant = type === 'All' ? 'All' : request.identifiers[0];
    try {
      const immersion = await apiClient(true).post(`/aggregate/v2/async/immersion/${request.tenant_id}/${request.session_code}`, { ...request });
      const safety = await apiClient(true).post(`/aggregate/v2/async/psych-readiness/${request.tenant_id}/${request.session_code}`, { ...request });
      dispatch(getGraphDataSuccess(activeParticipant, immersion.data, safety.data));
      dispatch(setLoading(false));
    } catch (e) {
      dispatch(setLoading(false));
    }
  }
};

export const getModeratedGraphData = async (request: any, tenant_id: string, session_code: string, type: string,) => {
  return async (dispatch: any) => {
    dispatch(setLoading(true));
    const activeParticipant = type === 'All' ? 'All' : request.identifiers[0];
    try {
      const immersion: any = await apiClient(true).post(`/aggregate/v2/sync/immersion/${tenant_id}/${session_code}`, { ...request });
      const safety: any = await apiClient(true).post(`/aggregate/v2/sync/psych-readiness/${tenant_id}/${session_code}`, { ...request });
      dispatch(getGraphDataSuccess(activeParticipant, immersion.data, safety.data));
      dispatch(setLoading(false));
    } catch (e) {
      dispatch(setLoading(false));
    }
  }
};

export const getStimulusInfo = (tenant_id: string, session_code: string | null) => {
  return async (dispatch: any) => {
    dispatch(setLoading(true));
    try {
      const res = await apiClient(true)
        .get(`/stimulus/v2/stimulus/${tenant_id}/${session_code}`);        
        if(res.data && res.data[0] ){
          dispatch(getStimulusInfoSuccess(res.data));
        }else{
          dispatch(getStimulusInfoSuccess([]));
        }
      dispatch(setLoading(false));
    } catch (e) {
      dispatch(setLoading(false));
    }
  }
};

export const getGraphDataForStartBtn = (request: any, tenant_id: string, session_code: string, type: string) => {
  return (dispatch: any) => {
    const activeParticipant = type === 'All' ? 'All' : request.identifiers[0];
    apiClient(true).post(`/aggregate/v2/sync/immersion/${tenant_id}/${session_code}`, { ...request })
      .then(res => {
        dispatch(getGraphDataStartBtnSuccess(activeParticipant, res.data));
      }).catch(() => {
        dispatch(setLoading(false));
      })
  }
};

export const getSessionParticipantsCode = (client: any, session_code: string | null) => {
  return (dispatch: any) => {
    if (session_code) {
      dispatch(setCodeLoading(true));
      client.query({
        query: ImmersionGQL.queryGetSessionParticipantsCode,
        fetchPolicy: "no-cache",
        variables: {
          session_code
        }
      }).then((res: any) => {
        if (res.data && res.data.getSessionParticipantsCode) {
          dispatch(updateIdentifiers(res.data.getSessionParticipantsCode));
          dispatch(getParticipantsCodeSuccess(res.data.getSessionParticipantsCode));
        }
        dispatch(setCodeLoading(false));
      }).catch(() => {
        dispatch(setCodeLoading(false));
      })
    }
  }
};

const updateAudienceImmersions = (data: any) => ({
  type: actionTypes.UPDATE_AUDIENCE_IMMERSIONS,
  payload: data
});

const updateAudienceSafes = (data: any) => ({
  type: actionTypes.UPDATE_AUDIENCE_SAFES,
  payload: data
});

const updateHighlights = (data: any) => ({
  type: actionTypes.UPDATE_HIGHLIGHTS,
  payload: data
});

const updateHighestSegments = (data: any) => ({
  type: actionTypes.UPDATE_HIGHEST_SEGMENTS,
  payload: data
});

const updateLowestSegments = (data: any) => ({
  type: actionTypes.UPDATE_LOWEST_SEGMENTS,
  payload: data
});

const updateAgendaImmersions = (data: any) => ({
  type: actionTypes.UPDATE_AGENDA_IMMERSIONS,
  payload: data
});

const updateAgendaSafes = (data: any) => ({
  type: actionTypes.UPDATE_AGENDA_SAFES,
  payload: data
});

export const initThumbnailUploaded = () => ({
  type: actionTypes.INIT_THUMBNAIL_UPLOADED,
  payload: null
});

const updateThumbnail = (data: any) => ({
  type: actionTypes.UPDATE_THUMBNAIL,
  payload: data
});

export const uploadThumbnail = (client: any, request: any) => {
  return (dispatch: any) => {
    dispatch(setLoading(true));
    const variables = { ...request };
    client.mutate({
      mutation: ImmersionGQL.mutationUploadThumbnail,
      fetchPolicy: "no-cache",
      variables
    }).then((res: any) => {
      dispatch(updateThumbnail(res.data.uploadThumbnail['data']));
      dispatch(setLoading(false));
    }).catch(() => {
      dispatch(updateThumbnail([]));
      dispatch(setLoading(false));
    });
  }
};

const updateOverviewAgendas = (data: any) => ({
  type: actionTypes.UPDATE_OVERVIEW_AGENDAS,
  payload: data
});

export const fetchSessionMarker = (client: any, request: any, cb: any) => {
  return (dispatch: any) => {
    dispatch(setLoading(true));
    const variables = { ...request };
    client.query({
      query: ImmersionGQL.queryFetchSessionMarker,
      fetchPolicy: "no-cache",
      variables
    }).then((res: any) => {
      dispatch(updateOverviewAgendas(res.data.fetchSessionMarker));
      dispatch({
        type: actionTypes.GET_FETCH_SESSION_MARKERS,
        payload: res.data.fetchSessionMarker
      });
      dispatch(setLoading(false));

      if (cb != null) {
        cb(res.data.fetchSessionMarker);
      }

    }).catch(() => {
      dispatch(updateOverviewAgendas([]));
      dispatch(setLoading(false));
    })
  }
};

export const updateIdentifiers = (data: any) => ({
  type: actionTypes.UPDATE_IDENTIFIERS,
  payload: data
});

export const getIdentifiers = (client: any, session_code: string) => {
  return (dispatch: any) => {
    client.query({
      query: ImmersionGQL.queryGetSessionParticipantsCode,
      fetchPolicy: "no-cache",
      variables: {
        session_code
      }
    }).then((res: any) => {
      dispatch(updateIdentifiers(res.data.getSessionParticipantsCode));
    }).catch(() => {
      dispatch(updateIdentifiers([]));
    })
  }
};

export const updateSessionData = (data: any) => ({
  type: actionTypes.UPDATE_SESSION_DATA,
  payload: data
});

export const getSessionData = (client: any, req: any) => {
  return (dispatch: any) => {
    client.query({
      query: ImmersionGQL.queryGetSessionParticipants,
      fetchPolicy: "no-cache",
      variables: {session_code: req.session_code}
    }).then((res: any) => {
      dispatch(updateSessionData(res.data.getSessionParticipants));
    }).catch(() => {
      dispatch(updateSessionData(null));
    })
  }
};

const updateFetching = (fetching: boolean) => ({
  type: actionTypes.UPDATE_FETCHING,
  payload: fetching
});

export const updateFullLoadedOverview = (loaded: boolean) => ({
  type: actionTypes.UPDATE_FULL_LOADED_OVERVIEW,
  payload: loaded
});

const calculatingOverviewTime = (time: number) => ({
  type: actionTypes.CALCULATE_OVERVIEW_TIME,
  payload: time
});

export const getOverview = (client: any, req: any) => {
  return (dispatch: any) => {
    dispatch(updateFetching(true));
    let time = -1;
    const interval = setInterval(() => {
      time = time + 1;
      dispatch(calculatingOverviewTime(time));
    }, 1000)
    client.query({
      query: ImmersionGQL.queryOverviewNew,
      fetchPolicy: "no-cache",
      variables: {...req}
    }).then((res: any) => {
      if (res.data.getOverviewData) {
        const mainData = res.data.getOverviewData;
        dispatch(getOverviewData(mainData));
        dispatch(calculatingOverviewTime(-1));
          clearInterval(interval);
        if (mainData.safety_aggregate_index) {
          const indexData = mainData.safety_aggregate_index;
          if (indexData.context_indicator) {
            dispatch(updateSafetyIndex(mainData.safety_aggregate_index));
          } else {
            dispatch(updateSafetyIndex(null));
          }
        } else {
          dispatch(updateSafetyIndex(null));
        }

        if (mainData.immersion_aggregate_index) {
          const indexData = mainData.immersion_aggregate_index;
          if (indexData.context_indicator) {
            dispatch(updateImmersionIndex(mainData.immersion_aggregate_index));
          } else {
            dispatch(updateImmersionIndex(null));
          }
        } else {
          dispatch(updateImmersionIndex(null));
        }

        if (mainData.bestMoments || mainData.worst_moments) {
          dispatch(updateHighlights(mainData))
        }

        if (mainData.audience_higher_immersion) {
          dispatch(updateHighestSegments(mainData.audience_higher_immersion))
        } else {
          dispatch(updateHighestSegments([]))
        }
        if (mainData.audience_lower_immersion) {
          dispatch(updateLowestSegments(mainData.audience_lower_immersion))
        } else {
          dispatch(updateLowestSegments([]))
        }

        if (mainData.immersion_contex_breakup) {
          dispatch(updateAudienceImmersions(mainData.immersion_contex_breakup))
        } else {
          dispatch(updateAudienceImmersions([]));
        }

        if (mainData.safety_contex_breakup) {
          dispatch(updateAudienceSafes(mainData.safety_contex_breakup))
        } else {
          dispatch(updateAudienceSafes([]));
        }

        setTimeout(() => {
          dispatch(updateFullLoadedOverview(true));
        }, 500);
        setTimeout(() => {
          dispatch(updateFetching(false));
        }, 3000);
      }else {
        // can't get overview data
        // window.location.reload();
      }
    }).catch(() => {
      dispatch(updateFetching(false));
      dispatch(calculatingOverviewTime(-1));
      clearInterval(interval);

      // can't get overview data
      // window.location.reload();

    })
  }
};

const updateFreeText = (free_text: string) => ({
  type: actionTypes.UPDATE_FREE_TEXT,
  payload: free_text
});

export const getNeedToKnow = (client: any, req: any) => {
  return (dispatch: any) => {
    dispatch(updateFetching(true));
    client.query({
      query: ImmersionGQL.queryGetNeedToKnow,
      fetchPolicy: "no-cache",
      variables: {...req}
    }).then((res: any) => {
      if (res.data.getNeedToKnow) {
        dispatch(updateFreeText(res.data.getNeedToKnow['data']['free_text']))
      }
    }).catch(() => {
      dispatch(updateFreeText(''))
    })
  }
};

export const updateExpThumbnail = (client: any, session_code: any) => {
    return (dispatch: any) => {
    if (session_code) {
      dispatch(setCodeLoading(true));
      client.query({
        query: ImmersionGQL.queryUpdateThumbnail,
        fetchPolicy: "no-cache",
        variables: {
          session_code
        }
      }).then((res: any) => {
        if (res.data && res.data.updateThumbnail) {
         dispatch(getOverview(client, {session_code:session_code}));         
        }
        dispatch(setCodeLoading(false));
      }).catch(() => {
        dispatch(setCodeLoading(false));
      })
    }
  }
};

export const getAgendaSafes = async (request: any) => {
  return async (dispatch: any) => {
    const { tenant_id, session_code } = request;
    try {
      setLoading(true);
      const res = await apiClient(true)
        .post(`/analysis/v2/sync/safety/range/${tenant_id}/${session_code}`, { ...request });
      if (res.data) {
        dispatch(updateAgendaSafes(res.data))
      } else {
        dispatch(updateAgendaSafes([]));
      }
      setLoading(false);
    } catch (e) {
      dispatch(updateAgendaSafes([]));
      setLoading(false);
    }
  }
};

export const getAgendaImmersions = async (request: any) => {
  return async (dispatch: any) => {
    const { tenant_id, session_code } = request;
    try {
      setLoading(true);
      const res = await apiClient(true)
        .post(`/analysis/v2/sync/immersion/range/${tenant_id}/${session_code}`, { ...request });
      if (res.data) {
        dispatch(updateAgendaImmersions(res.data))
      } else {
        dispatch(updateAgendaImmersions([]));
      }
      setLoading(false);
    } catch (e) {
      dispatch(updateAgendaImmersions([]));
      setLoading(false);
    }
  }
};

export const updateProjectFolderId = (items: any) => ({
  type: actionTypes.PROJECT_ID_UPDATE,
  payload: items,
});

export const onSetProjectID = (projectID: number) => ({
  type: actionTypes.SET_PROJECT_ID,
  payload: projectID
});

export const onSetTempProject = (tempProject: boolean) => ({
  type: actionTypes.SET_TEMP_PROJECT,
  payload: tempProject
});

export const getHashCode = (client: any, session_code: string, callback: any) => {
  return () => {
    client.query({
      query: ImmersionGQL.getHashCode,
      fetchPolicy: "no-cache",
      variables: {session_code: session_code}
    }).then((res: any) => {
      if (res.data.getHashCode) {
        callback(res.data.getHashCode);
      }
    }).catch(() => callback(null))
  }
};

export const replaceParticipantsTags = async (client: any, req: any) => {
  const variables = { ...req };
  return await client.mutate({
    mutation: ImmersionGQL.mutationReplaceParticipantsTags,
    fetchPolicy: "no-cache",
    variables
  });
};

const getManageHubsSuccess = (hubs: any[]) => ({
  type: actionTypes.GET_MANAGE_HUBS_SUCCESS,
  payload: hubs
});

export const getManageHubs = (client: any, request: any, callback?: any) => {
  return (dispatch: any) => {
    dispatch(setLoading(true));
    client.query({
      query: ImmersionGQL.getHubsQuery,
      fetchPolicy: "no-cache",
      variables: request
    }).then((res: any) => {
      dispatch(getManageHubsSuccess(res.data.listHubDevices));
      dispatch(setLoading(false));
      callback && callback(true);
    }).catch(() => {
      dispatch(getManageHubsSuccess([]));
      dispatch(setLoading(false));
      callback && callback(true);
    })
  }
};

export const onUpdateSelectedHubs = (selectedHubs: any[]) => ({
  type: actionTypes.UPDATE_SELECTED_HUBS,
  payload: selectedHubs
});

export const onEditSubCategory = (client: any, request: any, callback: any) => {
  return () => {
    client.mutate({
      mutation: ImmersionGQL.mutationEditSubCategory,
      fetchPolicy: "no-cache",
      variables: {...request}
    }).then(() => {
      callback(true)
    }).catch(() => {
      callback(true);
    })
  }
};